import { Component } from 'react';
import { NavLink as Link} from "react-router-dom";

import { callBackendAPI, generateSource, cancelToken } from './../helpers/common';

import errImg from './../assets/images/500-error.png';

export class ErrorBoundary extends Component {
	source;

	constructor(props) {
		super(props);
		this.state = {hasError: false };
	}

	static getDerivedStateFromError() {
		// Update state so the next render shows the fallback UI
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		/** Generate source for cancel token */
		this.source = generateSource();

		/** get data table data list */
		callBackendAPI([{ model: 'home', method: 'writeLogs', error : error.toString(), componentStack: errorInfo.componentStack}],this.source,false).then(response=>{
		}).catch(err => console.log(err));
	}

	componentWillUnmount(){
		cancelToken(this.source); // cancel the request
	}

  render() {
	if(this.state.hasError){
      return (
		<div className="login-page 404-page">
			<div className="container">
				<div className="row text-center">
					<div className="logo">
						<Link to="/">
							<figure>
								<img src={errImg} alt="logo"/>
							</figure>
						</Link>
					</div>
				</div>
			</div>
		</div>
      );
    }
    return this.props.children;
  }
};